<template>
  <v-container id="contact-grid" grid-list-xl>
    <section class="ftco-section">
      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-10">
          <div class="wrap d-md-flex">
            <v-card
              v-if="show"
              elevation="10"
              class="mx-auto my-12 p-2"
              max-width="474"
            >
              <v-card-title
                v-if="data.id_transaction"
                class="card-title justify-center"
              >
                {{ $t("payment_confirm") }}
              </v-card-title>
              <v-card-title v-else class="card-title justify-center">
                {{ $t("payment_pending") }}
              </v-card-title>
              <v-spacer></v-spacer>
              <v-divider width="300" class="mx-auto"></v-divider>
              <v-card-text class="card-text">
                {{ $t("success_demand") }}
                <strong>{{ data.full_name }}</strong>
                {{ $t("click_link") }}
                <v-card-actions>
                  <v-btn
                    color="white"
                    text
                    class="ma-2 pa-5 white--text warning mx-auto"
                    @click="demand"
                  >
                    {{ $t("requests") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
            <v-card
              v-if="!show"
              elevation="10"
              class="mx-auto my-12 p-2"
              max-width="474"
            >
              <v-card-title class="card-title justify-center">
                {{ $t("payment_pending") }}
              </v-card-title>
              <v-spacer></v-spacer>
              <v-divider width="300" class="mx-auto"></v-divider>
              <v-card-text class="card-text">
                <div class="spinner-border text-warning"></div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </section>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Payment",
  components: {},
  data() {
    return {
      code: null,
      data: null,
      show: false,
    };
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);

    this.$root.$i18n.locale = this.langLocal;
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get("code");
    this.getidtransaction;
  },
  watch: {
    data(val) {
      this.show = true;
      if (!val.full_name) {
        setTimeout(() => {
          this.$router.push("/demand");
        }, 30000);
      }
    },
  },
  computed: {
    ...mapGetters(["current_route", "user"]),
    
  },
  methods: {
    async getidtransaction() {
      let data = new FormData();
      data.append("codedemande", this.code);
      await this.$store.dispatch("getidtransaction", data).then((response) => {
        this.data = response;
        return this.data;
      });
    },
    demand() {
      this.$router.push("/demand");
    },
  },
};
</script>
<style scoped>
#site-header {
  margin-top: 100px;
}
.card-title {
  color: rgb(63, 53, 99);
  font-size: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.card-text {
  line-height: 2.5;
  text-align: center;
  font-size: 16px;
}
</style>
